export * from './ColorDetails';
export { default } from './ColorDetails';